import React from 'react';
import Layout from '../../components/ui/Layout';
import { Container } from 'react-bootstrap';
import { CONTACT_INFO } from '../../constants/contact';

export default function PrivacyPolicy() {
  return (
    <Layout>
      <Container className="mt-4">
        <h1>Privacy Policy</h1>
        <p>This Privacy Policy explains how we collect, use, and protect your information when you use our website and services. We are committed to safeguarding your privacy and ensuring your personal information is handled securely and responsibly.</p>
        <h4>Information We Collect</h4>
        <ul>
          <li>Personal identification information (Name, email address, phone number, etc.)</li>
          <li>Order and transaction details</li>
          <li>Usage data and cookies</li>
        </ul>
        <h4>How We Use Your Information</h4>
        <ul>
          <li>To process orders and manage your account</li>
          <li>To improve our services and website</li>
          <li>To communicate with you about your orders or updates</li>
        </ul>
        <h4>Contact Us</h4>
        <p>If you have any questions about this Privacy Policy, please contact us at {CONTACT_INFO.email}.</p>
      </Container>
    </Layout>
  );
} 